import { Button, IconFolderFilled, IconPlus } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../AppContext';
import { FolderListItem } from '../../viewModels/Folder';
import FolderModalContainer from './FolderModalContainer';

export interface AddFolderBtnProps {
    siblingFolderNames: Array<string>;
    parentFolder: FolderListItem | undefined;
    onNewFolder: (newFolder: FolderListItem) => void;
    orgId: string;
    groups: Map<string, string>;
    disabled: boolean;
};

const AddFolderBtn: FunctionComponent<AddFolderBtnProps> = props => {
    const { t } = useTranslation();
    const context = useContext(AppContext);

    const handleAddFolderBtnClick = () => {

        context.onShowModal('inputModal', {
            title: !props.parentFolder
                ? t('AddOrEditFolderModal.titleRoot', 'Create main folder')
                : t('AddOrEditFolderModal.titleSub', 'Create folder in "{{folderName}}"', { folderName: props.parentFolder?.name.toString() }),
            titleIcon: <IconFolderFilled />,
            content: <FolderModalContainer
                parentFolder={props.parentFolder}
                onSubmit={props.onNewFolder}
                siblingFolderNames={props.siblingFolderNames}
                orgId={props.orgId}
                groups={props.groups}
            />,
        });
    };

    return (
        <Button
            variant="primary"
            icon={<IconPlus />}
            onClick={handleAddFolderBtnClick}
            disabled={props.disabled}
        >
            {t('AddFolderBtn.button_title', 'Create folder')}
        </Button>
    );
};

export default AddFolderBtn;